<template>
  <el-dialog
    :model-value="show"
    :width="width"
    :show-close="false"
    :append-to-body="true"
    :close-on-click-modal="closeClickModal"
    @close="dialogOnCloseFn"
    @open="dialogOnOpenFn"
    style="padding: 0"
    align-center
  >
    <template #header
      ><div class="cust-dialog_header">
        <slot name="title" v-if="isCustTitle"></slot>
        <div v-else>{{ title }}</div>
        <i
          class="font_family icon-line19 closed-icon"
          @click="dialogOnCloseFn"
        ></i>
      </div>
    </template>
    <div class="cust-dialog_body">
      <slot name="content"></slot>
    </div>
    <template #footer>
      <div class="cust-dialog_body">
        <slot name="footer"></slot>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'

const emit = defineEmits(['closed', 'opend', 'update:show'])
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  isCustTitle: {
    type: Boolean,
    default: false,
  },
  show: {
    type: Boolean,
    required: true,
  },
  closeClickModal: {
    type: Boolean,
    default: true,
  },
  width: {
    type: String,
    default: '800',
  },
})
const dialogOnCloseFn = () => {
  emit('update:show', false)
  emit('closed')
}
const dialogOnOpenFn = () => {
  emit('opend')
}
</script>

<style lang="scss" scoped>
.cust-dialog_header {
  height: 39px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  font-size: var(--font-size-middle);
  border-bottom: 1px solid var(--border);

  .closed-icon {
    padding-left: 20px;
    font-size: var(--font-size-large24);
    cursor: pointer;
  }
}
.cust-dialog_body {
  padding: 0 10px;
}
</style>
